(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/teamstatistics/assets/javascripts/views/statteamformlatestmatches.js') >= 0) return;  svs.modules.push('/components/statistics/teamstatistics/assets/javascripts/views/statteamformlatestmatches.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.data = svs.statistics.data || {};

  var log = new svs.core.log.Logger('svs.statistics.StatTeamFormLatestMatches');

  svs.statistics.views.StatTeamFormLatestMatches = Backbone.View.extend({
    tagName: 'div',
    classId: 'StatTeamFormLatestMatches',
    viewId: 'statistik',
    statisticsMini: {},
    events: {
      'change #latestMatchesTableFilter': 'selectMenu',
      'change #latestMatchesHomeAwayFilter': 'selectMenu',
      'click .list-group-item': 'clicked'
    },
    matchHomeAwayFilter: 'all',
    matchNoFilter: 5,
    numOfMatches: 5,
    filters: {
      latestMatchesTableFilter: {
        filterValues: {},
        selectedKey: '',
        showDropDown: true
      },
      latestMatchesHomeAwayFilter: {
        filterValues: {
          all: { name: 'Alla', selected: true },
          home: { name: 'Hemma', selected: false },
          away: { name: 'Borta', selected: false }
        },
        selectedKey: 'all'
      }
    },
    initialize: function(options) {
      this.modelReference = options.modelReference;
      this.options = options.options;
      this.statisticsMini = {};
      this.filters.latestMatchesHomeAwayFilter.selectedKey = 'all';
    },
    update: function(model) {
      this.modelReference = model;
      this.render({});
    },
    clicked: function(event) {
      var matchId = $(event.currentTarget).data('match-id');
      var activeStatisticsMini = $(event.currentTarget).find(
        '.statistics-mini'
      );
      var statisticsMiniView = {};
      if ($(event.target).hasClass('show-statistics') && _.isNumber(matchId)) {
        if (!this.statisticsMini[matchId]) {
          this.statisticsMini[
            matchId
          ] = new svs.components.models.StatisticsMini({
            observer: this,
            parent: this,
            matchId: matchId,
            isLive: false
          });
          statisticsMiniView = new svs.components.views.StatisticsMini({
            modelReference: this.statisticsMini[matchId],
            parent: this
          });
          activeStatisticsMini.html(statisticsMiniView.el);
        }
      }
    },
    resize: function() {
      if (Object.prototype.hasOwnProperty.call(this.options.params, 'parent')) {
        this.options.params.parent.trigger('resize');
      }
    },
    render: function() {
      if (!this.modelReference) return;

      $(this.el).html(
        svs.statistics.teamstatistics.templates.statteamformlatestmatches(
          this.applyFilters()
        )
      );
      this.resize();
      return this;
    },
    selectMenu: function(event) {
      var callOptions = {};
      this.statisticsMini = {};
      var selectedVal = $(event.currentTarget).val();
      this.filters[$(event.currentTarget).attr('id')].selectedKey = selectedVal;
      var me = this;
      _.each(
        this.filters[$(event.currentTarget).attr('id')].filterValues,
        function(filterValue) {
          filterValue.selected = false;
          me.filters[$(event.currentTarget).attr('id')].filterValues[
            selectedVal
          ].selected = true;
        }
      );

      if ($(event.currentTarget).attr('id') === 'latestMatchesTableFilter') {
        this.matchNoFilter = selectedVal;
        this.numOfMatches = this.filters[
          $(event.currentTarget).attr('id')
        ].filterValues[selectedVal].numOfMatches;

        callOptions.selection = this.matchHomeAwayFilter;

        if (callOptions.selection === 'all') {
          callOptions.selection = '';
        }

        this.modelReference.updateTeamFormLatest(callOptions, function(
          error,
          data
        ) {
          if (!error) {
            var updatedData = me.modelReference.parseFormLatestMatchesStatistics(
              data,
              me.matchHomeAwayFilter
            );
            me.modelReference.set('statistics', updatedData.statistics, {
              silent: true
            });
            me.render({});
          } else {
            log.error('Could not fetch match statistics', error);
          }
        });
      }
      if ($(event.currentTarget).attr('id') === 'latestMatchesHomeAwayFilter') {
        this.matchHomeAwayFilter = selectedVal;
        callOptions.selection = this.matchHomeAwayFilter;

        if (callOptions.selection === 'all') {
          callOptions.selection = '';
        }

        this.modelReference.updateTeamFormLatest(callOptions, function(
          error,
          data
        ) {
          if (!error) {
            var updatedData = me.modelReference.parseFormLatestMatchesStatistics(
              data,
              me.matchHomeAwayFilter
            );
            me.modelReference.set('statistics', updatedData.statistics, {
              silent: true
            });
            me.render({});
          } else {
            log.error('Could not fetch match statistics', error);
          }
        });
      }
    },
    applyFilters: function() {
      var self = this,
        oLatestMatches;

      var statistics = this.modelReference.get('statistics');

      if (statistics) {
        if (_.isObject(statistics.latestMatches)) {
          if (
            _.isObject(
              statistics.latestMatches[
                self.filters.latestMatchesHomeAwayFilter.selectedKey
              ]
            )
          ) {
            var homeMatches =
              statistics.latestMatches[
                self.filters.latestMatchesHomeAwayFilter.selectedKey
              ];
            var latestMatches = homeMatches;
            for (var i = 0; i < latestMatches.length - 2; i++) {
              self.filters.latestMatchesTableFilter.filterValues[i] = {
                name: 'Matcher (' + (latestMatches.length - i) + ')',
                selected: false,
                numOfMatches: latestMatches.length - i
              };
            }
            if (!self.inited) {
              self.inited = true;
              self.matchNoFilter = latestMatches.length - 5;
              if (self.matchNoFilter < 0) self.matchNoFilter = 0;
            }
          }
        }
      }

      _.each(this.filters.latestMatchesTableFilter.filterValues, function(
        filterValue
      ) {
        filterValue.selected = false;
        self.filters.latestMatchesTableFilter.filterValues[
          self.matchNoFilter
        ].selected = true;
      });

      _.each(this.filters.latestMatchesHomeAwayFilter.filterValues, function(
        filterValue
      ) {
        filterValue.selected = false;
        self.filters.latestMatchesHomeAwayFilter.filterValues[
          self.matchHomeAwayFilter
        ].selected = true;
      });

      var latestMatchesData = this.getLatestMatchesObject();
      statistics = latestMatchesData.statistics;

      oLatestMatches = latestMatchesData.oLatestMatches;
      if (!oLatestMatches) {
        oLatestMatches = {};
      }
      var matches = latestMatchesData.oLatestMatches.latestMatchesHome;

      return {
        statistics: statistics,
        latestMatchesHome: oLatestMatches,
        matches: matches,
        filters: this.filters
      };
    },

    getLatestMatchesObject: function() {
      var statistics = this.modelReference.get('statistics');
      var oLatestMatches;

      if (statistics) {
        if (_.isObject(statistics.latestMatches)) {
          oLatestMatches = {};
          var matches = {};

          var currentTeamId = parseInt(this.modelReference.currentTeamId, 10);
          matches.result = JSON.parse(
            JSON.stringify(
              _.first(
                statistics.latestMatches[
                  this.filters.latestMatchesHomeAwayFilter.selectedKey
                ],
                this.numOfMatches
              )
            )
          );

          var history = svs.utils.result.getLatestAndTrend(
            matches,
            0,
            currentTeamId,
            null
          );
          var homeMatchLatest = history.latest;
          var homeMatchTrend = svs.utils.result.getCurrentTrend(history.trend);

          matches.result.forEach(function(match) {
            if (
              svs.utils.ns.isNamespace('match.homeTeam', match) &&
              svs.utils.ns.isNamespace('match.awayTeam', match) &&
              svs.utils.ns.isNamespace('match.result.home', match) &&
              svs.utils.ns.isNamespace('match.result.away', match)
            ) {
              match.match.homeTeam.result = match.match.result.home;
              match.match.awayTeam.result = match.match.result.away;
            }
          });

          statistics.participants = [
            { latest: homeMatchLatest, trend: homeMatchTrend }
          ];

          oLatestMatches.latestMatchesHome = matches.result;

          if (history.numGoalsPerMatchFor) {
            oLatestMatches.numGoalsPerMatchFor = (
              history.numGoalsPerMatchFor / this.numOfMatches
            )
              .toFixed(2)
              .replace('.', ',');
          }
        }
      }
      return { statistics: statistics, oLatestMatches: oLatestMatches };
    },
    onDestroy: function() {
      this.undelegateEvents();
      if (this.modelReference) {
        this.modelReference.off('change', this.render, this);
      }
      this.remove();
      Backbone.View.prototype.remove.call(this);
    }
  });
})(Backbone, _, svs);

 })(window);